/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import { z } from "zod";

export const propertyDescriptionSchema = z.object({
      "general": z.string().optional(),
  "partner": z.string().optional(),
  "web": z.string().optional(),
  "slideshow": z.string().optional(),
  "magazine": z.string().optional(),
  "other": z.string().optional()
      })